import InputLabel from 'domains/core/components/InputLabel';
import Select from 'domains/core/components/Select';
import TextField from 'domains/core/components/TextField';
import { VoiceContentAction, VoiceContentInteraction } from 'pages/ContentVoiceBuilderPage/types';
import { updateInteraction } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    index: number;
    interaction: VoiceContentInteraction;
};

const ActionSelect = ({ dispatchVoiceContentAction, index, interaction }: Props) => {
    const isOptOut = interaction.type === VoiceContentAction.DO_NOT_DISTURB;

    if (isOptOut) {
        return (
            <TextField
                defaultValue="Opt-Out"
                disabled
                label={<InputLabel label="Action" labelIconTooltipText="Opt-out is mandatory for all voice calls." />}
                sx={{ width: '200px' }}
                type="string"
            />
        );
    }

    const handleSelectedActionChange = (action: VoiceContentAction) => {
        const updatedInteraction = {
            keypadOption: interaction.keypadOption,
            type: action,
        };
        dispatchVoiceContentAction(updateInteraction(updatedInteraction, index));
    };

    return (
        <Select
            label="Choose Action"
            onChange={(e: any) => handleSelectedActionChange(e.target.value)}
            sx={{ width: '200px' }}
            type="string"
            value={interaction?.type ?? ''}
            values={[
                { label: 'Play Message', value: VoiceContentAction.PLAY_MESSAGE },
                { label: 'Transfer Call', value: VoiceContentAction.TRANSFER },
            ]}
        />
    );
};

export default ActionSelect;
